import { getOrderTime, isOpenOrder, Order } from '../entities/shared';
import EntityStore from './entity';

const MAX_CLOSED_ORDERS = 25;
export default class OrdersStore extends EntityStore<Order> {
  constructor() {
    const sortComparer = (orderA: Order, orderB: Order) =>
      getOrderTime(orderB) - getOrderTime(orderA);

    super({ sortComparer });
  }

  /**
   * Updates an order in the store. If the order is closed and the store
   * has more than the max number of closed orders, the oldest closed
   * order is removed.
   * @param order
   */
  updateClosedOrder(order: Order) {
    const closedOrders = this.selectAll().filter((o) => !isOpenOrder(o));

    if (closedOrders.length > MAX_CLOSED_ORDERS) {
      // orders are sorted in descending order, so the oldest order is the last one
      const oldestOrder = closedOrders[closedOrders.length - 1];
      if (oldestOrder != null) this.removeOne(oldestOrder.id);
    }
    this.setOne(order);
  }
}
